import { Navigate, useLocation } from "react-router-dom";
import { isSellerAuthenticated } from "../api/marketplaceAuth";
export default function SellerRoute({ children }) {
  const location = useLocation();
  return isSellerAuthenticated() ? children : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
